import React, { createContext, useContext, useState } from "react";
import { ToastContainer } from "react-toastify";

const BeefreeTemplateBlueprintEditorContext = createContext();

export function useBeefreeTemplateBlueprintEditorContext() {
  return useContext(BeefreeTemplateBlueprintEditorContext);
}

const BeefreeTemplateBlueprintEditorProvider = (props) => {
  const {
    csrfToken,
    user,
    team,
    beefreeTemplateBlueprint: initialBlueprint,
    beefreeToken,
    beefreeTemplateBlueprintBaseUrl,
  } = props;

  const [beefreeTemplateBlueprint, setBeefreeTemplateBlueprint] = useState(initialBlueprint);
  const [showComposer, setShowComposer] = useState(!!initialBlueprint.template);

  const value = {
    csrfToken,
    user,
    team,
    beefreeTemplateBlueprint,
    setBeefreeTemplateBlueprint,
    beefreeToken,
    beefreeTemplateBlueprintBaseUrl,
    showComposer,
    setShowComposer,
  };

  return (
    <BeefreeTemplateBlueprintEditorContext.Provider value={value}>
      <ToastContainer icon={false} />
      {props.children}
    </BeefreeTemplateBlueprintEditorContext.Provider>
  );
};

const BeefreeTemplateBlueprintEditorContainer = (props) => (
  <BeefreeTemplateBlueprintEditorProvider {...props}>
    {props.children}
  </BeefreeTemplateBlueprintEditorProvider>
);

export default BeefreeTemplateBlueprintEditorContainer;
